import cx from 'classnames';

import { type Masked, unmask } from '~/contentful/graphql';
import PlusIcon from '~/ui/assets/icons/plus.svg';
import typographyStyles from '~/ui/styles/typography.module.scss';

import styles from './trigger.module.scss';
import { type GrantStoryAccordionCard_GrantActivityArticleFragment } from '../query';

interface TriggerProps {
  data: Masked<typeof GrantStoryAccordionCard_GrantActivityArticleFragment>;
  onClick?: () => void;
  disabled: boolean;
}

export function AccordionTrigger({ data, onClick, disabled }: TriggerProps) {
  const { title } = unmask<typeof GrantStoryAccordionCard_GrantActivityArticleFragment>(data);
  return (
    <button className={styles.accordionTrigger} onClick={onClick} disabled={disabled}>
      <div className={styles.iconWrapper}>
        <PlusIcon className={styles.icon} />
      </div>
      <div className={styles.content}>
        <div className={cx(styles.titleLabel, typographyStyles.bodySmall)}>{title}</div>
      </div>
    </button>
  );
}
